
    import { mapState } from 'vuex'
    import { Component, Inject, Vue } from 'vue-property-decorator'
    import Layout from '../../common/components/layout/layout.vue'
    import { Invoice } from '@/app/invoice/entities/invoice.entity'
    import { InvoiceLine } from '@/app/invoice/entities/invoice-line.entity'
    import { GetAllInvoicesCommand } from '@/app/invoice/commands/get-all-invoices.command'
    import { DownloadInvoiceCommand } from '@/app/invoice/commands/download-invoice.command'
    import { NotificationDispatcher } from '@/app/common/services/notification-dispatcher.service'

    @Component({
        components: { Layout },
        metaInfo() {
            return {
                title: 'Invoices'
            }
        },
        computed: {
            ...mapState('invoice', ['invoices'])
        }
    })
    export default class InvoiceList extends Vue {
        invoices!: Invoice[]
        loading: string[] = []

        @Inject() getAllInvoicesCommand!: GetAllInvoicesCommand
        @Inject() downloadInvoiceCommand!: DownloadInvoiceCommand
        @Inject() notificationDispatcher!: NotificationDispatcher

        mounted() {
            this.getAllInvoicesCommand.run()
        }

        isIndented(invoice: Invoice, index: number): boolean {
            if (!this.isDiscount(invoice.lines[index])) {
                return false
            }

            // Indenting only says something when there is a service line above
            // it for the discount to belong to.
            return invoice.lines.slice(0, index).some(line => !this.isDiscount(line))
        }

        isDiscount(line: InvoiceLine): boolean {
            // Accelerate flags discounts, and they are also the only lines that
            // subtract from the invoice, which older versions do not flag.
            return line.isDiscount || line.amount < 0
        }

        goToInvoicePayment(productActionApiId: string) {
            this.$router.push({ name: 'invoice-payment', params: { action: productActionApiId } })
        }

        async downloadInvoice(id: string) {
            try {
                this.loading.push(id)
                await this.downloadInvoiceCommand.run(id)
            } catch (err) {
                await this.notificationDispatcher.error(err.message)
            } finally {
                this.loading = this.loading.filter(item => item !== id)
            }
        }
    }
